<template>
  <div class="verificationCodeBtn active tapActive" v-text="btnText" :class="{ disabled: verificationCodeInfo.disabled }" @click="btnEvent"></div>
  <!-- <button class="mini-btn myEditClass tapActiveStatus1" type="primary" size="mini" plain="true" v-text="btnText" :disabled="verificationCodeInfo.disabled" @click="btnEvent"></button> -->
</template>

<script>
export default {
  props: {
    verificationCodeInfo: {
      type: Object,
      default: {
        disabled: true
      }
    }
  },
  data() {
    return {
      btnText: '获取验证码',
      timer: null,
      countdownTime: 60
    }
  },
  methods: {
    btnEvent() {
      if (!this.verificationCodeInfo.disabled) {
        this.startCountdown()
      }
    },
    startCountdown() {
      this.$emit('btnTapHandler')
      this.timer = setInterval(() => {
        if (this.countdownTime === 0) {
          clearInterval(this.timer)
          this.timer = null
          this.btnText = '获取验证码'
          this.countdownTime = 60
          return
        }
        this.btnText = this.countdownTime + 's'
        this.countdownTime--
      }, 1000)
    }
  },
  watch: {
    timer() {
      this.$emit('changeDisabledStatus')
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}

.verificationCodeBtn {
  font-size: vw(14);
  &.active {
    color: #63a6f9;
  }
  &.disabled {
    color: #e3e3e3;
  }
}
.mini-btn.myEditClass {
  border: 1px solid #a0a0a0;
  color: #000;
  // width: vw(200);
  border-radius: vw(100);
}

.tapActiveStatus1:active {
  border: 1px solid #1cc21b;
  color: #1cc21b;
}
</style>
